<script async src="https://js.stripe.com/v3/pricing-table.js"></script>
<div class="min-h-screen flex flex-col bg-gray-50">
  <app-auth-header></app-auth-header>

  <!-- Hero Section -->
  <div class="bg-gradient-to-br from-jamaica-green-600 to-jamaica-green-900 py-4">
    <div class="container mx-auto px-4 text-center">
      <h1 class="text-3xl font-bold mb-4 text-white">Find Quality Stocks "On Sale"</h1>
      <p class="text-lg mb-4 text-white">
        Choose the right plan for your investment journey
      </p>
      <p class="text-md opacity-90 text-white">Save up to 17% with yearly billing</p>
    </div>
  </div>
<div class="container mx-auto px-4 py-8">
<stripe-pricing-table
  [attr.pricing-table-id]="pricingTableId"
  [attr.publishable-key]="publishableKey"
  [attr.customer-email]="customerEmail()">
</stripe-pricing-table>
</div>
<!-- FAQ Section -->
  <div class="mt-16 max-w-4xl mx-auto">
    <h2 class="text-3xl font-bold text-center text-green-800 mb-8">
      Frequently Asked Questions
    </h2>
    <p-accordion [multiple]="false" class="w-full faq-accordion">
      <p-accordion-panel value="0">
        <p-accordion-header>Can I switch plans later?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            Yes! You can upgrade or downgrade your plan at any time. Changes take
            effect immediately, and we'll prorate any charges.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="1">
        <p-accordion-header>What payment methods do you accept?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            We accept all major credit cards (Visa, MasterCard, American Express)
            and debit cards through our secure payment processor, Stripe.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="2">
        <p-accordion-header>Is there a free trial?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            Yes! Both the Yardie and Boss Man plans come with a 14-day free trial.
            No credit card required to start. You can cancel anytime during the
            trial period.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="3">
        <p-accordion-header>Can I cancel my subscription?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            Absolutely. You can cancel your subscription at any time from your
            account settings. You'll continue to have access until the end of your
            billing period.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="4">
        <p-accordion-header>Do you offer refunds?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            We offer a 30-day money-back guarantee. If you're not satisfied with
            your subscription, contact us within 30 days for a full refund.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
      <p-accordion-panel value="5">
        <p-accordion-header>What's the difference between monthly and yearly billing?</p-accordion-header>
        <p-accordion-content>
          <p class="text-gray-700">
            Yearly billing gives you 2 months free (17% discount). You pay upfront
            for the entire year and save compared to paying monthly.
          </p>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <!-- CTA Section -->
  <div class="mt-16 bg-gradient-to-r from-green-600 to-green-700 shadow-xl p-12 text-center">
    <h2 class="text-3xl font-bold text-white mb-4">
      Ready to Start Your Investment Journey?
    </h2>
    <p class="text-xl text-white mb-8">
      Join thousands of investors finding quality stocks "on sale"
    </p>
    <p-button
      label="Get Started For Free"
      styleClass="p-4 text-lg bg-yellow text-black"      
      (click)="selectPlan('free')"
    >
    </p-button>
    <p class="text-white text-sm mt-4 opacity-90">
      No credit card required • 14-day free trial on paid plans
    </p>
  </div>

  <app-auth-footer></app-auth-footer>
</div>
